import {useFetchEffect} from 'hooks/useFetchEffect'
import {useHistory, useLocation} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import {Form} from 'procedures/changeDependents/remove/Form'
import api from 'api'
import {actionCreators} from 'actions'
import queryString from 'query-string'
import {asyncError} from 'store/actions/asyncError'
import {makeDependentInitialValues} from './Form'

const makeInitialValues = (employee, dependentIds = []) => {
  const dependents = employee.employee_dependents

  return dependents
    ? {
        dependents: dependents
          .filter((dep) => dependentIds.includes(String(dep.id)))
          .map((dependent) => makeDependentInitialValues(dependent)),
      }
    : {}
}

export const Detail = () => {
  const history = useHistory()
  const {search} = useLocation()
  const {employee_id: employeeId, dependentIds} = queryString.parse(search, {arrayFormat: 'bracket'})
  const dispatch = useDispatch()
  const employee = useSelector((state) => state.employees.current.data)
  const token = useSelector((state) => state.auth.token)
  const healthInsuranceType = employee.office?.health_insurance_type

  const loadEmployee = () => {
    dispatch(
      actionCreators.employees.current.fetchData(
        api.createWithAuth(token).employees.get(employeeId, ['employee_dependents', 'office'])
      )
    )
  }
  const updateAndCreateProcedure = async ({dependents, date_on: dateOn}) => {
    const authedApi = api.createWithAuth(token)
    try {
      const {
        data: {id},
      } = await authedApi.procedureStatuses.start(employeeId, 'remove_dependents', dateOn, 'draft', false)
      for (let dependent of dependents) {
        await authedApi.employees.dependents.update(employeeId, dependent)
        await authedApi.procedureStatuses.removeDependentsData.create(id, dependent.id, dependent.is_report_target)
      }
      await authedApi.procedureStatuses.update(id, {initialized: true})
      history.push(`/remove_dependents/flow/${id}`)
    } catch (err) {
      dispatch(asyncError(err))
    }
  }

  useFetchEffect(() => {
    loadEmployee()
    return () => dispatch(actionCreators.employees.current.destroy())
  }, [])

  return (
    <Form
      onSubmit={updateAndCreateProcedure}
      initialValues={makeInitialValues(employee, dependentIds)}
      employee={employee}
      healthInsuranceType={healthInsuranceType}
    />
  )
}
